import { RemoteHandleStudentsNoAppUsage } from 'data/usecases';
import { HandleStudentsNoAppUsageUseCaseInterface } from 'domain/usecases';
import { makeApiUrlStudentsNoAppUsage } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeHandleStudentsNoAppUsageUse =
  (): HandleStudentsNoAppUsageUseCaseInterface =>
    new RemoteHandleStudentsNoAppUsage(
      makeApiUrlStudentsNoAppUsage(),
      makeAxiosHttpClient(),
    );
